import { define } from 'wicked-elements'
import bus from '../bus'

define('[data-component~="grid-filter-dropdown"]', {
  init () {
    this.key = this.element.getAttribute('data-key')
    this.$grid = document.querySelector('[data-component="grid"]')
    this.handleChange = this.handleChange.bind(this)
    this.handleSetFilter = this.handleSetFilter.bind(this)
    this.filter = null
  },
  connected () {
    this.element.addEventListener('change', this.handleChange)
    bus.on('filter:set', this.handleSetFilter)
  },
  disconnected () {
    this.element.removeEventListener('change', this.handleChange)
    bus.removeListener('filter:set', this.handleSetFilter)
  },
  handleChange (e) {
    this.filter = e.target.value
    this.$grid.setAttribute('has-filter', this.filter)
    bus.emit('filter:set', {
      key: this.key,
      value: this.filter
    })
  },
  handleSetFilter ({ key, value }) {
    if (key !== this.key) {
      this.element.value = ""
      this.filter = null
    } else {
      this.element.value = value || ""
      this.filter = value
    }
  }
})